import { render, staticRenderFns } from "./Whitelabeling.vue?vue&type=template&id=632f5b16&"
import script from "./Whitelabeling.vue?vue&type=script&lang=js&"
export * from "./Whitelabeling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports